import React from 'react';
import { Zap, Brain } from 'lucide-react';

const CallToAction = () => {
  return (
    <section className="text-center mt-20 md:mt-28 py-12 bg-gray-800/60 rounded-lg shadow-xl px-6 backdrop-blur-md">
      <Zap className="w-16 h-16 text-sky-400 mx-auto mb-6 animate-subtle-pulse" strokeWidth={1.5} />
      <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl mb-6">
        Amplify Your Data. Accelerate Your Research.
      </h2>
      <p className="max-w-3xl mx-auto text-lg text-gray-300 mb-8">
        Stop sifting, start researching. Data Revival provides the AI-powered lens to bring clarity and structure to your vast swathes of locked data. We empower you to harness the full potential of your chemical data, efficiently and effectively.
      </p>
      <a
        href="mailto:contact@data-revival.com"
        className="inline-flex items-center justify-center bg-sky-500 hover:bg-sky-600 text-gray-900 font-semibold py-3 px-8 rounded-lg shadow-md transition duration-300 ease-in-out transform hover:scale-105"
      >
        Learn How Data Revival Can Help You
        <Brain className="ml-2 h-5 w-5" />
      </a>
    </section>
  );
};

export default CallToAction;